export const MASTER_PIN_ACTIONS = [
  { key: "login", label: "Login Access" },
  { key: "dashboard", label: "Dashboard Access" },
  { key: "inventory", label: "Inventory Evaluation" },
  { key: "inventory_add", label: "Inventory Add" },
  { key: "inventory_price_unlock", label: "Inventory Unlock Price" },
  { key: "salary_unlock", label: "Salary Unlock (Employee Page)" },
  { key: "salary_history", label: "Salary History" },
  { key: "employee_base_salary_unlock", label: "Employee Base Salary Unlock" },
];

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export const getEmployeeIdForProtectedAction = (fallbackUser = null) => {
  const user = fallbackUser && typeof fallbackUser === "object" ? fallbackUser : getStoredUser();
  const employeeId = user?.id ?? user?.employee_id ?? user?._id ?? "";
  return employeeId === "" || employeeId === null || employeeId === undefined
    ? ""
    : String(employeeId);
};
